import type { TaskField as TaskFieldType } from '@certhon/models';
import { useListContext, useFieldActions } from '../context';
import { AnnotationIndicators } from './AnnotationIndicators';
import { FieldFeedbackBadge } from '@/features/feedback/components/FieldFeedbackBadge';
import { FieldTitle } from './FieldTitle';
import { FieldWrapper } from './FieldWrapper';
import { TaskControl } from './TaskControl';

interface TaskFieldProps {
  field: TaskFieldType;
  isActive?: boolean;
  isEven?: boolean;
  onSelect?: (fieldId: string) => void;
}

export function TaskField({
  field,
  isActive,
  isEven,
  onSelect,
}: TaskFieldProps) {
  const { mode } = useListContext();
  const actions = useFieldActions(field.id);

  const disabled = mode === 'view';

  return (
    <FieldWrapper
      fieldId={field.id}
      isActive={isActive}
      isEven={isEven}
      onClick={onSelect ? () => onSelect(field.id) : undefined}
    >
      <FieldTitle field={field} />
      <AnnotationIndicators attachments={field.attachments} />
      <FieldFeedbackBadge fieldId={field.id} size="small" />
      <TaskControl
        value={field.value}
        onChange={(v) => actions.patch({ value: v })}
        disabled={disabled}
      />
    </FieldWrapper>
  );
}
